import Header from './Header';
import Content from './Content';
import ToDoList from './ToDoList';

export default function Main() {
  return (
    <div id="main">
      <Header />
      <Content />
      <ToDoList />
    </div>
  );
}
